<template>
  <GeneralLink
    v-if="link"
    v-bind="link"
    :class="{
      'mb-10px text-center text-15px font-semibold text-www-color-primary-lighter hover:text-www-color-primary-pale lg:mb-0 lg:text-left': true,
    }"
  />
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import type { CustomerSideBarLink } from '@/sanity/types';
defineProps<CustomerSideBarLink>();
</script>

<style></style>
